import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Question, Words } from '../../../model';

import { environment } from '../../../../';
import { CookieManagerService, ErrorManagerService, HttpClientService } from '../../../../shared';

@Component({
  selector: 'app-gp2-tp5r',
  templateUrl: './gp2-tp5r.component.html',
  styleUrls: ['./gp2-tp5r.component.css','../../../../css/paper-layouts.component.css']
})
export class Gp2Tp5rComponent implements OnInit {

  @Input() question: Question;
  @Input() isSubmit: boolean;
  @Input() type: string;
  tempwords: Array<Words> = [];
  answers: Array<Words> = [];

  constructor(private httpClientService: HttpClientService,
    private route: ActivatedRoute,
    private cookieManagerService: CookieManagerService,
    private ErrorManagerService: ErrorManagerService) { }

  ngOnInit() {
    this.answers = [];
    this.tempwords = [];
    this.question.correctAnswer.words.forEach(element => {
      this.answers.push(element);
    });
     if(this.question.words){
      this.question.words.forEach(element => {
          this.tempwords.push(element);
          
      });
    }
  }

  selectedWordListId(i){
    this.answers.push(this.tempwords[i]);
    this.tempwords.splice(i, 1);
    this.selectCorrectAnswer(this.answers)
    
  }

  selectedaswersListId(i){
    this.tempwords.push(this.answers[i]);
    this.answers.splice(i, 1);
  }

  selectCorrectAnswer(answer){
    this.question.answerIds = answer;
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/paper-layouts/group/gp2-tp5r/gp2-tp5r.component.ts